function RichTextEditorLink({ attributes, element, children }: any) {
  return (
    <a {...attributes} className="text-indigo-400 underline" href={element.href}>
      {children}
    </a>
  );
}

export default RichTextEditorLink;
